"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "castelbello-ciardes": {
    "48fe7e37": [{
      "hkey": "8acab02f",
      "slug": "castelbello-ciardes",
      "name": "Castelbello-Ciardes",
      "primary": true,
      "skipSearch": false
    }],
    "montefontana": [{
      "hkey": "8acab02f",
      "slug": "castelbello-ciardes",
      "name": "Castelbello-Ciardes",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "aa6dd32d": [{
      "hkey": "047bbc15",
      "slug": "monte-trumes",
      "name": "Monte Trumes",
      "primary": true,
      "skipSearch": false
    }],
    "montetrumes": [{
      "hkey": "047bbc15",
      "slug": "monte-trumes",
      "name": "Monte Trumes",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;